/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Download_TitleInputs */

const en_cad_page_download_title = /** @type {(inputs: Cad_Page_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft Download: Windows, macOS & Linux Install Guide`)
};

/**
* | output |
* | --- |
* | "CADCraft Download: Windows, macOS & Linux Install Guide" |
*
* @param {Cad_Page_Download_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_download_title = /** @type {((inputs?: Cad_Page_Download_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Download_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_download_title(inputs)
});
export { cad_page_download_title as "cad.page.download.title" }